import React from 'react';
import { Package, Briefcase, Luggage, Plus, Minus } from 'lucide-react';

export const LOCKER_SIZES = [
  { id: 'small', name: 'S', label: 'Small', price: 1.5, icon: Package, dimensions: '28×50×43 cm' },
  { id: 'medium', name: 'M', label: 'Medium', price: 2.0, icon: Briefcase, dimensions: '65×38×60 cm' },
  { id: 'xlarge', name: 'XL', label: 'Extra Large', price: 3.0, icon: Luggage, dimensions: '97×45×60 cm' },
];

export const MAX_QUANTITIES = { small: 5, medium: 12, xlarge: 8 };

const MultiLockerSelector = ({ lockerQuantities, onQuantityChange }) => {
  // lockerQuantities = { small: 0, medium: 0, xlarge: 0 }
  
  const handleIncrement = (sizeId) => {
    const maxQty = MAX_QUANTITIES[sizeId];
    const currentQty = lockerQuantities[sizeId] || 0;
    if (currentQty < maxQty) {
      onQuantityChange({
        ...lockerQuantities,
        [sizeId]: currentQty + 1
      });
    }
  };

  const handleDecrement = (sizeId) => {
    const currentQty = lockerQuantities[sizeId] || 0;
    if (currentQty > 0) {
      onQuantityChange({
        ...lockerQuantities,
        [sizeId]: currentQty - 1
      });
    }
  };

  const getTotalLockers = () => {
    return Object.values(lockerQuantities).reduce((sum, qty) => sum + qty, 0);
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <label className="text-[#FFCC00] text-sm font-semibold uppercase tracking-wider">
          Seleziona i Locker
        </label>
        <span className="text-gray-400 text-sm">
          {getTotalLockers()} locker selezionati
        </span>
      </div>
      
      {LOCKER_SIZES.map(locker => {
        const IconComponent = locker.icon;
        const quantity = lockerQuantities[locker.id] || 0;
        const maxQty = MAX_QUANTITIES[locker.id];
        const isSelected = quantity > 0;
        
        return (
          <div
            key={locker.id}
            data-testid={`locker-size-${locker.id}`}
            className={`
              w-full p-4 border transition-all
              ${isSelected
                ? 'bg-[#FFCC00]/10 border-[#FFCC00]'
                : 'bg-[#0A0A0A] border-[#2A2A2A]'
              }
            `}
          >
            <div className="flex items-center gap-4">
              <IconComponent className={`w-10 h-10 ${isSelected ? 'text-[#FFCC00]' : 'text-white'}`} />
              
              <div className="flex-1">
                <p className="text-white font-bold text-lg">{locker.name} - {locker.label}</p>
                <p className="text-gray-500 text-xs">{locker.dimensions}</p>
                <p className="text-[#FFCC00] font-semibold">€{locker.price.toFixed(2).replace('.', ',')}/ora</p>
              </div>
              
              <div className="flex items-center gap-3">
                <button
                  type="button"
                  onClick={() => handleDecrement(locker.id)}
                  disabled={quantity === 0}
                  className="w-10 h-10 bg-[#0A0A0A] border border-[#2A2A2A] text-white hover:border-[#FFCC00] transition-colors flex items-center justify-center disabled:opacity-30 disabled:cursor-not-allowed"
                  data-testid={`locker-${locker.id}-decrease`}
                >
                  <Minus className="w-4 h-4" />
                </button>
                
                <span 
                  className={`text-xl font-bold w-8 text-center ${isSelected ? 'text-[#FFCC00]' : 'text-white'}`}
                  data-testid={`locker-${locker.id}-quantity`}
                >
                  {quantity}
                </span>
                
                <button
                  type="button"
                  onClick={() => handleIncrement(locker.id)}
                  disabled={quantity >= maxQty}
                  className="w-10 h-10 bg-[#0A0A0A] border border-[#2A2A2A] text-white hover:border-[#FFCC00] transition-colors flex items-center justify-center disabled:opacity-30 disabled:cursor-not-allowed"
                  data-testid={`locker-${locker.id}-increase`}
                >
                  <Plus className="w-4 h-4" />
                </button>
              </div>
            </div>
            
            {quantity > 0 && (
              <div className="mt-2 pt-2 border-t border-[#2A2A2A] flex justify-between text-sm">
                <span className="text-gray-400">Disponibili: {maxQty}</span>
                <span className="text-[#FFCC00]">
                  Subtotale: €{(locker.price * quantity).toFixed(2).replace('.', ',')}/ora
                </span>
              </div>
            )}
          </div>
        );
      })}
      
      {getTotalLockers() === 0 && (
        <p className="text-gray-500 text-sm text-center py-2">
          Seleziona almeno 1 locker per continuare
        </p>
      )}
    </div>
  );
};

export default MultiLockerSelector;
